import React, { Component } from 'react'
import moment from 'moment'

import ExploriDatePicker from '../../../ExploriDatePicker'
import Button from '../../../../UniformComponents/Button'
import Panel from '../../../../UniformComponents/Panel'
import Select from '../../../form/Select'
import Date from '../../../form/Date'
import DataTable from '../../../DataTable'
import Accordion from '../../../Report/components/Accordion'
import { sortByNameCaseInsensitive } from '../../../helpers'

import './licenceCounter.scss'

class LicenceCounter extends Component {
    startDate

    endDate

    clientId

    productCols = [
        {
            name: 'ProductId',
            key: 'productId',
        },
        {
            name: 'Name',
            key: 'productName',
        },
    ]

    surveyCols = [
        {
            name: 'surveyId',
            key: 'surveyId',
        },
        {
            name: 'Survey',
            key: 'surveyName',
        },
    ]

    constructor(props) {
        super(props)

        const { store } = this.props

        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'licencecounter',
                url: '/intranet/licencecounter',
                title: 'Licence Counter',
            },
        ]

        this.state = {
            clients: [],
            products: [],
            benchmarkProducts: [],
            maxbiProducts: [],
            surveys: [],
            benchmarkSurveys: [],
            maxbiSurveys: [],
        }
    }

    async componentDidMount() {
        const { store } = this.props
        const response = await store.http.get('/client')
        const clientOptions = response.clients.map(({ clientId, name }) => ({
            value: clientId,
            label: `${name} [${clientId}]`,
        }))

        this.setState({
            clients: sortByNameCaseInsensitive(clientOptions),
        })
    }

    changeDate = (k, { value }) => {
        const time = value.format('YYYY-MM-DD')
        console.log('changeDate', k, time, value)
        this[k] = time
    }

    changeClient = ({ value }) => {
        this.clientId = value
    }

    search = async () => {
        const { store } = this.props
        const { startDate, endDate, clientId } = this

        if (!startDate || !endDate || !clientId) {
            store.handleError({ body: 'Start date, end date and clientId are required', level: 'error' })
            return
        }

        const licences = await store.http.get(`/intranet/licencecounter/${clientId}?startDate=${startDate}&endDate=${endDate}$live=true`)

        const { products, surveys, benchmarkProducts, maxbiProducts, benchmarkSurveys, maxbiSurveys } = licences.reduce((map, licence) => {
            if (!Object.hasOwnProperty.call(map.products, licence.productId) && !['PE', 'EM'].includes(licence.surveyType)) {
                map.products[licence.productId] = {
                    productId: licence.productId,
                    productName: licence.productName,
                }
            } else if (!Object.hasOwnProperty.call(map.benchmarkProducts, licence.productId) && ['PE'].includes(licence.surveyType)) {
                map.benchmarkProducts[licence.productId] = {
                    productId: licence.productId,
                    productName: licence.productName,
                }
            } else if (!Object.hasOwnProperty.call(map.maxbiProducts, licence.productId) && ['EM'].includes(licence.surveyType)) {
                map.maxbiProducts[licence.productId] = {
                    productId: licence.productId,
                    productName: licence.productName,
                }
            }

            if (!Object.hasOwnProperty.call(map.surveys, licence.surveyId) && !['PE', 'EM'].includes(licence.surveyType)) {
                map.surveys[licence.surveyId] = {
                    surveyId: licence.surveyId,
                    surveyName: licence.surveyName,
                }
            } else if (!Object.hasOwnProperty.call(map.benchmarkSurveys, licence.surveyId) && ['PE'].includes(licence.surveyType)) {
                map.benchmarkSurveys[licence.surveyId] = {
                    surveyId: licence.surveyId,
                    surveyName: licence.surveyName,
                }
            } else if (!Object.hasOwnProperty.call(map.maxbiSurveys, licence.surveyId) && ['EM'].includes(licence.surveyType)) {
                map.maxbiSurveys[licence.surveyId] = {
                    surveyId: licence.surveyId,
                    surveyName: licence.surveyName,
                }
            }

            return map
        }, {
            products: {},
            surveys: {},
            benchmarkProducts: {},
            maxbiProducts: {},
            benchmarkSurveys: {},
            maxbiSurveys: {},
        })

        this.setState({
            products: Object.values(products),
            surveys: Object.values(surveys),
            benchmarkProducts: Object.values(benchmarkProducts),
            maxbiProducts: Object.values(maxbiProducts),
            benchmarkSurveys: Object.values(benchmarkSurveys),
            maxbiSurveys: Object.values(maxbiSurveys),
        })
    }

    render() {
        const {
            clients,
            products,
            surveys,
            benchmarkProducts,
            maxbiProducts,
            benchmarkSurveys,
            maxbiSurveys,
        } = this.state
        return (
            <Panel cssClass="licenceCounter">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Date
                        label="Start Date"
                        onBlur={(value) => this.changeDate('startDate', value)}
                        placeholder="Start Date"
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Date
                        label="End Date"
                        onBlur={(value) => this.changeDate('endDate', value)}
                        placeholder="End Date"
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                    />
                </div>
                <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
                    <Select
                        label="Client"
                        placeholder="Select client"
                        options={clients}
                        onBlur={this.changeClient}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button
                        label="Submit"
                        cssClass="regular primary"
                        onClick={this.search}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Products (${products.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={products}
                            columns={this.productCols}
                            numRows={products.length}
                        />
                    </Accordion>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Benchmarking Products (${benchmarkProducts.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={benchmarkProducts}
                            columns={this.productCols}
                            numRows={benchmarkProducts.length}
                        />
                    </Accordion>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Maxbi Products (${maxbiProducts.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={maxbiProducts}
                            columns={this.productCols}
                            numRows={maxbiProducts.length}
                        />
                    </Accordion>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Surveys (${surveys.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={surveys}
                            columns={this.surveyCols}
                            numRows={surveys.length}
                        />
                    </Accordion>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Benchmarking Surveys (${benchmarkSurveys.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={benchmarkSurveys}
                            columns={this.surveyCols}
                            numRows={benchmarkSurveys.length}
                        />
                    </Accordion>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className="accordion">
                    <Accordion title={`Maxbi Surveys (${maxbiSurveys.length})`}>
                        <DataTable
                            store={{}}
                            inMemory
                            dataSet={maxbiSurveys}
                            columns={this.surveyCols}
                            numRows={maxbiSurveys.length}
                        />
                    </Accordion>
                </div>
            </Panel>
        )
    }
}

export default LicenceCounter
